import React, { useRef } from 'react';
import _ from 'lodash';
import PropTypes from 'prop-types';
import i18n from 'i18next';
import cx from 'classnames';
import ModalDialog from '../ui/modal-dialog';
import Form from '../ui/form';
var t = i18n.getFixedT(null, 'logistic-deliver');
var gt = i18n.getFixedT(null, 'app');
var EIRDetail = /*#__PURE__*/React.memo(function (props) {
  var id = props.id,
      onClose = props.onClose,
      data = props.data;
  var form_ref = useRef(null);
  var fields = {};

  _.set(fields, 'eirContainerModel', {
    label: t('dlg-eirContainerModel')
  });

  _.set(fields, 'eirEmptyContainerWeight', {
    label: t('dlg-eirEmptyContainerWeight'),
    formatter: function formatter(val) {
      return parseInt(val) === -1 ? t('lbl-no-data') : val;
    }
  });

  _.set(fields, 'eirVslOwner', {
    label: t('dlg-eirVslOwner')
  });

  _.set(fields, 'eirVslRegNo', {
    label: t('dlg-eirVslRegNo')
  }); // dailog action


  var actions = {};

  _.set(actions, 'cancel', {
    text: gt('global.lbl-close'),
    handler: onClose
  });

  return /*#__PURE__*/React.createElement(ModalDialog, {
    id: id,
    title: t('lbl-has-eir'),
    global: true // info={error}
    // infoClassName={cx({'c-error':error})}
    ,
    actions: actions,
    closeAction: "cancel"
  }, /*#__PURE__*/React.createElement(Form, {
    id: "".concat(id, "-form-left"),
    ref: form_ref,
    className: "pure-form-aligned",
    fieldClassName: "pure-control-group",
    fields: fields,
    value: data
  }));
});
EIRDetail.defaultProps = {
  id: 'g-eir-detail'
};
EIRDetail.propTypes = {
  id: PropTypes.string
};
export default EIRDetail;